// extracted by mini-css-extract-plugin
module.exports = {"title":"Form__title--f2u","description":"Form__description--1Ew","form":"Form__form--159","error":"Form__error--3Wm","submit":"Form__submit--1X2"};